import {
    FETCHING_POWER_GUIDANCE_START,
    FETCHING_POWER_GUIDANCE_ERROR,
    FINISHED_FETCHING_POWER_GUIDANCE,
    SET_POWER_GUIDANCE_COURSE_NAME,
    SET_POWER_GUIDANCE_SUMMARY_FROM_ALGORITHM_DATA,
    FETCH_POWER_GUIDANCE_COURSE_DETAILS_SUCCESS,
    FETCH_POWER_GUIDANCE_DETAILS_SUCCESS,
    SET_SPECIFIC_DATA_TO_POWER_GUIDE,
    SET_POWER_GUIDANCE_SPLITS_FROM_ALGORITHM_DATA,
    SAVE_POWER_GUIDANCE_SUCCESS,
    UPDATE_POWER_GUIDANCE_SUCCESS,
    DELETE_POWER_GUIDANCE_SUCCESS,
    FETCH_FITNESS_STATS_START,
    FETCH_FITNESS_STATS_ERROR,
    FETCH_FITNESS_STATS_SUCCESS,
    UPDATE_POWER_ZONES_SUCCESS,
    SAVE_POWER_ZONES_FROM_USER_INFO_SUCCESS,
    RESET_POWER_GUIDANCE_DATA,
    UPDATE_POWER_GUIDANCE_FAIL,
    SAVE_POWER_GUIDANCE_FAIL,
    DELETE_POWER_GUIDANCE_ERROR,
    RESET_POWER_GUIDANCE_DELETE_ERROR,
    RESET_POWER_GUIDANCE_DUPLICATE_ERROR,
    UPDATE_POWER_ZONES_START,
    UPDATE_POWER_ZONES_ERROR,
    FETCH_LATEST_FUNCTIONAL_THRESHOLD_SUCCESS,
    SET_EVENT_FOR_POWER_GUIDE,
    SET_POWER_GUIDE_FROM_EVENT,
    DUPLICATE_POWER_GUIDANCE_ERROR,
    FINISHED_FETCHING_POWER_GUIDE_BY_COURSE_ID,
    SET_NUTRITION_AND_HYDRATION_WEATHER_FORECAST_TYPE,
    SET_NUTRITION_AND_HYDRATION_CUSTOM_TEMPERATURE,
    SET_NUTRITION_AND_HYDRATION_RECOMMENDATION_DATA,
    SET_NUTRITION_AND_HYDRATION_TODAY_TEMPERATURE,
    SET_POWER_GUIDE_FROM_CREATE,
    RESET_NUTRITION_AND_HYDRATION_DATA
} from 'actions/ActionTypes';
import { WEATHER_OPTIONS } from '../../PowerGuidance/Components/NutritionAndHydration/utils/NutritionAndHydrationUtils';

const NUTRITION_AND_HYDRATION_INITIAL_STATE = {
    metricHydrationTotalValueInML: 0,
    metricNutritionTotalValueLowInGrams: 0,
    metricNutritionTotalValueHighInGrams: 0,
    metricIntervalInSeconds: 0,
    metricHydrationIntervalValueInML: 0,
    metricNutritionIntervalValueLowInGrams: 0,
    metricNutritionIntervalValueHighInGrams: 0,
    statuteHydrationTotalValueInOz: 0,
    statuteNutritionTotalValueLowInGrams: 0,
    statuteNutritionTotalValueHighInGrams: 0,
    statuteIntervalInSeconds: 0,
    statuteHydrationIntervalValueInOz: 0,
    statuteNutritionIntervalValueLowInGrams: 0,
    statuteNutritionIntervalValueHighInGrams: 0,
    feedbackPhraseKey: null,
    effortMaxDurationInHours: 0,
    temperatureCelsius: 0,
    heatIndexTemperatureCelsius: 0
};

const INITIAL_STATE = {
    powerGuidanceList: [],
    powerGuidanceListFetching: false,
    powerGuidanceListByCourseId: [],
    updatePowerZoneSuccess: false,
    wereChangesMade: false,
    powerGuideUpdated: false,
    powerGuideSaveFail: false,
    fetchingPowerGuidanceError: false,
    deletePowerGuideanceError: false,
    duplicatePowerGuideanceError: false,
    latestFunctionalThresholdPower: false,
    courseData: null,
    powerGuidanceData: {
        powerGuidancePk: null, // not set if not in edit mode
        powerGuidanceSummary: {
            powerGuidancePk: null, // not set if not in edit mode
            powerGuidanceName: '', //set initialy as course name if not in edit mode
            coursePk: null, // done calculations in setSummaryDataFromAlgorithm
            userProfilePk: null, //done calculations in setSummaryDataFromAlgorithm
            goalEffort: 0.5, //default value, set via setSpecificDataToPowerGuideDetails
            userFTP: null, // set via setSpecificDataToPowerGuideDetails
            splitCount: null, //done calculations in setSummaryDataFromAlgorithm
            aeroCoefficient: 0.5, // set via CalculateAeroCoefficient
            rollingResistanceCoefficient: 0.5, // set via CalculateRollingResistanceCoefficient
            riderMass: null, // set via setSpecificDataToPowerGuideDetails
            bikeMass: 0, // set via setSpecificDataToPowerGuideDetails todo set the correct bike mass when available and the default value
            minSegmentLength: null, // not implemented yet
            elevationSegmentTolerance: null, // not implemented yet
            estimatedDuration: null, //done calculations in setSummaryDataFromAlgorithm
            ftpUsagePercent: null, //done calculations in setSummaryDataFromAlgorithm
            meanPowerUsage: null, //done calculations in setSummaryDataFromAlgorithm
            maxPowerUsage: null, //done calculations in setSummaryDataFromAlgorithm
            distance: null, //done - course distance -  calculations in setSummaryDataFromAlgorithm
            aeroProfile: 'STANDARD',
            terrainProfile: 'GRAVEL',
            estimatedDurationHigh: 0,
            estimatedDurationLow: 0
        },
        powerGuidanceSplits: null,
        fitnessStats: [],
        fitnessStatsFetching: false,
        fitnessStatsError: false,
        powerZones: [],
        event: {},
        powerGuideFromEvent: false
    },
    powerGuideFromCreate: false,
    fetchingNutritionAndHydrationError: false,
    nutritionAndHydrationRecommendationData: {
        today: NUTRITION_AND_HYDRATION_INITIAL_STATE,
        event: NUTRITION_AND_HYDRATION_INITIAL_STATE,
        custom: NUTRITION_AND_HYDRATION_INITIAL_STATE
    },
    nutritionAndHydrationWeatherData: {
        todayTemperatureCelsius: 0,
        todayFeelsLikeTemperatureCelsius: 0,
        selectedForecast: WEATHER_OPTIONS.TODAY_FORECAST,
        customTemperatureCelsius: 22
    }
};

const requestingPowerGuidanceList = (state) => {
    return {
        ...state,
        powerGuidanceListFetching: true
    };
};
const requestingPowerGuidanceListError = (state) => {
    return {
        ...state,
        powerGuidanceListFetching: false,
        fetchingPowerGuidanceError: true
    };
};

const requestingPowerGuidanceListFinished = (state, action) => {
    return {
        ...state,
        fetchingPowerGuidanceError: false,
        powerGuidanceListFetching: false,
        powerGuidanceList: action.data
    };
};

const requestingPowerGuideListByCourseIdFinished = (state, action) => {
    return {
        ...state,
        powerGuidanceListByCourseId: action.data
    };
};

const setEventForPowerGuide = (state, action) => {
    return {
        ...state,
        event: action.value
    };
};

const setPowerGuideFromEvent = (state, action) => {
    return {
        ...state,
        powerGuideFromEvent: action.value
    };
};

const setPowerGuideFromCreate = (state, action) => {
    return {
        ...state,
        powerGuideFromCreate: action.value
    };
};

const setPowerGuidanceName = (state, action) => {
    return {
        ...state,
        wereChangesMade: true,
        powerGuidanceData: {
            ...state.powerGuidanceData,
            powerGuidanceSummary: {
                ...state.powerGuidanceData.powerGuidanceSummary,
                powerGuidanceName: action.value
            }
        }
    };
};

const setPowerGuidanceCourseData = (state, action) => {
    if (action.overWritePowerGuidance) {
        return {
            ...state,
            courseData: {
                ...action.course
            },
            powerGuidanceData: {
                ...state.powerGuidanceData,
                powerGuidanceSummary: {
                    ...state.powerGuidanceData.powerGuidanceSummary,
                    powerGuidanceName: action.course.courseName,
                    coursePk: action.course.courseId
                }
            }
        };
    } else {
        //this if for when editing the power guidance, we dont want to overwrite the set power guidance data
        return {
            ...state,
            courseData: {
                ...action.course
            }
        };
    }
};

const setPowerGuideSaveFailStatus = (state, action) => {
    return {
        ...state,
        powerGuideSaveFail: true
    };
};

const setPowerGuideDetails = (state, action) => {
    let powerGuideUpdatedStatus = false;

    if (action.type === UPDATE_POWER_GUIDANCE_SUCCESS) {
        //do not do this on initial fetch for existing power guidances (aka FETCH_POWER_GUIDANCE_DETAILS_SUCCESS)
        powerGuideUpdatedStatus = true;
    }

    return {
        ...state,
        wereChangesMade: false,
        powerGuideSaveFail: false,
        powerGuideUpdated: powerGuideUpdatedStatus,
        powerGuidanceData: {
            ...action.data
        }
    };
};

const setSpecificDataToPowerGuideDetails = (state, action) => {
    return {
        ...state,
        wereChangesMade: true,
        powerGuidanceData: {
            ...state.powerGuidanceData,
            powerGuidanceSummary: {
                ...state.powerGuidanceData.powerGuidanceSummary,
                [action.key]: action.value
            }
        }
    };
};

const setPowerGuidanceSummaryFromAlgorithmData = (state, action) => {
    return {
        ...state,
        powerGuidanceData: {
            ...state.powerGuidanceData,
            powerGuidanceSummary: {
                //summary is not overwritten in entirety for edit scenario
                ...state.powerGuidanceData.powerGuidanceSummary,
                ...action.summary
            }
        }
    };
};

const setPowerGuidanceSplitsFromAlgorithmData = (state, action) => {
    return {
        ...state,
        powerGuidanceData: {
            ...state.powerGuidanceData,
            powerGuidanceSplits: [
                //splits are completly recalculated - array of objects
                ...action.splits
            ]
        }
    };
};

const resetPowerGuidanceData = (state, action) => {
    return {
        ...INITIAL_STATE
    };
};

const requestingFitnessStats = (state) => {
    return {
        ...state,
        fitnessStatsFetching: true
    };
};
const requestingFitnessStatsError = (state) => {
    return {
        ...state,
        fitnessStatsFetching: false,
        fitnessStatsError: true
    };
};

const requestingFitnessStatsFinished = (state, action) => {
    return {
        ...state,
        fitnessStatsError: false,
        fitnessStatsFetching: false,
        fitnessStats: action.data
    };
};

const updatePowerZonesSuccess = (state, action) => {
    return {
        ...state,
        updatePowerZoneSuccess: true
    };
};

const fetchLatestFunctionalThresholdPowerSuccess = (state, action) => {
    return {
        ...state,
        latestFunctionalThresholdPower: action.data
    };
};

const savePowerZonesFromUserInfo = (state, action) => {
    return {
        ...state,
        updatePowerZoneSuccess: true,
        powerZones: action.response.data
    };
};

const setPowerGuidanceDeleteFail = (state) => {
    return {
        ...state,
        deletePowerGuideanceError: true
    };
};

const resetPowerGuidanceDeleteFail = (state) => {
    return {
        ...state,
        deletePowerGuideanceError: false
    };
};

const setPowerGuidanceDuplicateFail = (state) => {
    return {
        ...state,
        duplicatePowerGuideanceError: true
    };
};

const resetPowerGuidanceDuplicateFail = (state) => {
    return {
        ...state,
        duplicatePowerGuideanceError: false
    };
};

const updatePowerZonesFetchStatus = (state) => {
    return {
        ...state,
        updatePowerZoneSuccess: false
    };
};

const setNutritionAndHydrationWeatherForecast = (state, action) => {
    return {
        ...state,
        nutritionAndHydrationWeatherData: {
            ...state.nutritionAndHydrationWeatherData,
            selectedForecast: action.value
        }
    };
};

const setNutritionAndHydrationCustomTemperature = (state, action) => {
    return {
        ...state,
        nutritionAndHydrationWeatherData: {
            ...state.nutritionAndHydrationWeatherData,
            customTemperatureCelsius: action.value
        }
    };
};

const setNutitionAndHydrationTodayTemperature = (state, action) => {
    return {
        ...state,
        nutritionAndHydrationWeatherData: {
            ...state.nutritionAndHydrationWeatherData,
            todayTemperatureCelsius: action.todayTemperatureCelsius,
            todayFeelsLikeTemperatureCelsius: action.todayFeelsLikeTemperatureCelsius
        }
    };
};

const setNutritionAndHydrationRecommendationData = (state, action) => {
    return {
        ...state,
        nutritionAndHydrationRecommendationData: {
            ...state.nutritionAndHydrationRecommendationData,
            [action.forecastType]: action.data
        }
    };
};

const resetNutritionAndHydrationRecommendationData = (state) => {
    return {
        ...state,
        nutritionAndHydrationRecommendationData: INITIAL_STATE.nutritionAndHydrationRecommendationData,
        nutritionAndHydrationWeatherData: INITIAL_STATE.nutritionAndHydrationWeatherData
    };
};

const handlers = {
    [FETCHING_POWER_GUIDANCE_START]: requestingPowerGuidanceList,
    [FETCHING_POWER_GUIDANCE_ERROR]: requestingPowerGuidanceListError,
    [FINISHED_FETCHING_POWER_GUIDANCE]: requestingPowerGuidanceListFinished,
    [FINISHED_FETCHING_POWER_GUIDE_BY_COURSE_ID]: requestingPowerGuideListByCourseIdFinished,
    [SET_POWER_GUIDANCE_COURSE_NAME]: setPowerGuidanceName,
    [SET_POWER_GUIDANCE_SUMMARY_FROM_ALGORITHM_DATA]: setPowerGuidanceSummaryFromAlgorithmData,
    [SET_POWER_GUIDANCE_SPLITS_FROM_ALGORITHM_DATA]: setPowerGuidanceSplitsFromAlgorithmData,
    [FETCH_POWER_GUIDANCE_COURSE_DETAILS_SUCCESS]: setPowerGuidanceCourseData,
    [FETCH_POWER_GUIDANCE_DETAILS_SUCCESS]: setPowerGuideDetails,
    [SET_SPECIFIC_DATA_TO_POWER_GUIDE]: setSpecificDataToPowerGuideDetails,
    [SAVE_POWER_GUIDANCE_SUCCESS]: resetPowerGuidanceData,
    [DELETE_POWER_GUIDANCE_SUCCESS]: resetPowerGuidanceData,
    [RESET_POWER_GUIDANCE_DATA]: resetPowerGuidanceData,
    [UPDATE_POWER_GUIDANCE_SUCCESS]: setPowerGuideDetails,
    [UPDATE_POWER_GUIDANCE_FAIL]: setPowerGuideSaveFailStatus,
    [SAVE_POWER_GUIDANCE_FAIL]: setPowerGuideSaveFailStatus,
    [FETCH_FITNESS_STATS_START]: requestingFitnessStats,
    [FETCH_FITNESS_STATS_ERROR]: requestingFitnessStatsError,
    [FETCH_FITNESS_STATS_SUCCESS]: requestingFitnessStatsFinished,
    [UPDATE_POWER_ZONES_START]: updatePowerZonesFetchStatus,
    [UPDATE_POWER_ZONES_ERROR]: updatePowerZonesFetchStatus,
    [UPDATE_POWER_ZONES_SUCCESS]: updatePowerZonesSuccess,
    [SAVE_POWER_ZONES_FROM_USER_INFO_SUCCESS]: savePowerZonesFromUserInfo,
    [DELETE_POWER_GUIDANCE_ERROR]: setPowerGuidanceDeleteFail,
    [RESET_POWER_GUIDANCE_DELETE_ERROR]: resetPowerGuidanceDeleteFail,
    [RESET_POWER_GUIDANCE_DUPLICATE_ERROR]: resetPowerGuidanceDuplicateFail,
    [DUPLICATE_POWER_GUIDANCE_ERROR]: setPowerGuidanceDuplicateFail,
    [FETCH_LATEST_FUNCTIONAL_THRESHOLD_SUCCESS]: fetchLatestFunctionalThresholdPowerSuccess,
    [SAVE_POWER_ZONES_FROM_USER_INFO_SUCCESS]: savePowerZonesFromUserInfo,
    [SET_EVENT_FOR_POWER_GUIDE]: setEventForPowerGuide,
    [SET_POWER_GUIDE_FROM_EVENT]: setPowerGuideFromEvent,
    [SET_POWER_GUIDE_FROM_CREATE]: setPowerGuideFromCreate,
    [SET_NUTRITION_AND_HYDRATION_WEATHER_FORECAST_TYPE]: setNutritionAndHydrationWeatherForecast,
    [SET_NUTRITION_AND_HYDRATION_CUSTOM_TEMPERATURE]: setNutritionAndHydrationCustomTemperature,
    [SET_NUTRITION_AND_HYDRATION_RECOMMENDATION_DATA]: setNutritionAndHydrationRecommendationData,
    [SET_NUTRITION_AND_HYDRATION_TODAY_TEMPERATURE]: setNutitionAndHydrationTodayTemperature,
    [RESET_NUTRITION_AND_HYDRATION_DATA]: resetNutritionAndHydrationRecommendationData
};

export const powerGuidanceList = (state) => state.powerGuidance.powerGuidanceList;
export const powerGuidanceListIsFetching = (state) => state.powerGuidance.powerGuidanceListFetching;
export const getPowerGuidanceCourseData = (state) => state.powerGuidance.courseData;
export const getPowerGuidanceSummary = (state) => state.powerGuidance.powerGuidanceData.powerGuidanceSummary;
export const getPowerGuidanceSplits = (state) => state.powerGuidance.powerGuidanceData.powerGuidanceSplits;
export const wereChangesMade = (state) => state.powerGuidance.wereChangesMade;
export const fitnessStatsData = (state) => state.powerGuidance.fitnessStats;
export const fitnessStatsIsFetching = (state) => state.powerGuidance.fitnessStatsFetching;
export const getBikeAndGearWeight = (state) => state.powerGuidance.powerGuidanceData.powerGuidanceSummary.bikeMass;
export const updatePowerZoneRequestState = (state) => state.powerGuidance.updatePowerZoneSuccess;
export const wasPowerGuideUpdated = (state) => state.powerGuidance.powerGuideUpdated;
export const hasPowerGuideSaveFailed = (state) => state.powerGuidance.powerGuideSaveFail;
export const hasPowerGuideDeleteFailed = (state) => state.powerGuidance.deletePowerGuideanceError;
export const hasPowerGuideDuplicateFailed = (state) => state.powerGuidance.duplicatePowerGuideanceError;
export const getLatestFunctionalThresholdPower = (state) => state.powerGuidance.latestFunctionalThresholdPower;
export const getCalendarEvent = (state) => state.powerGuidance.event;
export const getPowerGuideFromEvent = (state) => state.powerGuidance.powerGuideFromEvent;
export const getPowerGuideFromCreate = (state) => state.powerGuidance.powerGuideFromCreate;
export const getPowerGuideListByCourseId = (state) => state.powerGuidance.powerGuidanceListByCourseId;
export const getPowerGuidancePk = (state) => state.powerGuidance.powerGuidanceData.powerGuidancePk;

export const getNutritionAndHydrationWeatherData = (state) => state.powerGuidance.nutritionAndHydrationWeatherData;
export const getNutritionAndHydrationRecommendationData = (state) =>
    state.powerGuidance.nutritionAndHydrationRecommendationData;

export default function powerGuidance(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
